function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Breadcrumb");

var SvgBreadcrumb = function SvgBreadcrumb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M47.41,46.22a.13.13,0,0,0-.1,0,.12.12,0,0,0-.09,0l-.36.36a.1.1,0,0,0,0,.09.13.13,0,0,0,0,.1L48,47.91,46.86,49a.14.14,0,0,0,0,.1.13.13,0,0,0,0,.1l.36.35a.12.12,0,0,0,.09,0,.13.13,0,0,0,.1,0L49,48a.11.11,0,0,0,0-.09.13.13,0,0,0,0-.1Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M86.45,45.6H56.92a2.4,2.4,0,0,0,0,4.8H86.45a2.4,2.4,0,0,0,0-4.8Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M39.08,45.6H9.55a2.4,2.4,0,0,0,0,4.8H39.08a2.4,2.4,0,0,0,0-4.8Z",
    style: {
      fill: "#ccc"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBreadcrumb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BREADCRUMB.608bbf42.svg";
export { ForwardRef as ReactComponent };